var WarmupQuestions = require("lib/academic/WarmupQuestions");

class NonFictionOrganizationQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[NonFictionOrganizationQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [NUM_PAGES_STAGE];
		}
		
		if (!answers[NUM_PAGES] || answers[NUM_PAGES] < 1) {
			return [NUM_PAGES_STAGE];
		}

		if (this.props.level == "1") {
			if (!answers[SEL_HEADING_NUMBER] || !answers[NUM_HEADINGS] || answers[NUM_HEADINGS] < 1) {
				return [ORG_STRUCTURE_STAGE];
			}

			if (!answers[SEL_HEADING_DESCRIPTION]) {
				return [RANDOM_HEADING_STAGE];
			} else {
				return [RANDOM_HEADING_STAGE, true];
			}
		}

		if (!answers[STRUCTURE_TYPE]) {
			return [ORG_STRUCTURE_STAGE];
		}

		var structure = answers[STRUCTURE_TYPE];
		if (structure.includes("chronological")) {
			if (!answers[EVENT_1] || !answers[EVENT_2]) {
				return [CHRONOLOGICAL_STAGE];
			} else {
				return [CHRONOLOGICAL_STAGE, true];
			}
		}
		if (structure.includes("compare")) {
			if (!answers[SPECIFIC_ENTITY_1] || !answers[SPECIFIC_ENTITY_2]) {
				return [COMPARISON_STAGE];
			} else {
				return [COMPARISON_STAGE, true];
			}
		}
		if (structure.includes("cause")) {
			if (!answers[CAUSE] || !answers[EFFECT]) {
				return [CAUSE_EFFECT_STAGE];
			} else {
				return [CAUSE_EFFECT_STAGE, true];
			}
		}
		if (structure.includes("problem")) {
			if (!answers[PROBLEM] || !answers[SOLUTION]) {
				return [PROBLEM_SOLUTION_STAGE];
			} else {
				return [PROBLEM_SOLUTION_STAGE, true];
			}
		}
		if (structure.includes("descriptive")) {
			if (!answers[SUBJECT] || !answers[DESCRIPTION]) {
				return [DESCRIPTION_STAGE];
			} else {
				return [DESCRIPTION_STAGE, true];
			}
		}
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var numPagesDisplay = (
			<div>
				{ this.props.getTextF("label1", NUM_PAGES_STAGE) }
				{ this.props.renderInputF(NUM_PAGES, null, "number") }
				{ this.props.getTextF("label2", NUM_PAGES_STAGE) }.
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0) {
			if (this.props.level == "1") {
				var orgStructureDisplay = (
					<div>
						{ this.props.getTextF("label1", ORG_STRUCTURE_STAGE) }
						{ this.props.renderInputF(NUM_HEADINGS, null, "number") }
						{ this.props.getTextF("label2", ORG_STRUCTURE_STAGE) }.
					</div>
				);
			} else {
				var orgStructureDisplay = (
					<div>
						{ this.props.getTextF("label1", ORG_STRUCTURE_STAGE) }
						{ this.props.renderDropdownF("choices1", ORG_STRUCTURE_STAGE, STRUCTURE_TYPE, [NUM_PAGES]) }.
					</div>
				);
			}
		}

		if (_.indexOf(STAGES, stage) == 2) {
			var answers = this.props.answers[NonFictionOrganizationQuestion.STEM];
			var replacementsHash = {};
			replacementsHash[WarmupQuestions.HEADING_NUMBER] = answers[SEL_HEADING_NUMBER];

			var randomHeadingDisplay = (
				<div>
					{ this.props.getTextF("label1", RANDOM_HEADING_STAGE, replacementsHash) }
					{ this.props.renderInputF(SEL_HEADING_DESCRIPTION) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) == 3) {
			var chronologicalDisplay = (
				<div>
					{ this.props.getTextF("label1", CHRONOLOGICAL_STAGE) }
					{ this.props.renderInputF(EVENT_1) }
					<br />
					{ this.props.getTextF("label2", CHRONOLOGICAL_STAGE) }
					{ this.props.renderInputF(EVENT_2) }
				</div>
			);
		}
		if (_.indexOf(STAGES, stage) == 4) {
			var comparisonDisplay = (
				<div>
					{ this.props.getTextF("label1", COMPARISON_STAGE) }
					{ this.props.renderInputF(SPECIFIC_ENTITY_1) }
					<br />
					{ this.props.getTextF("label2", COMPARISON_STAGE) }
					{ this.props.renderInputF(SPECIFIC_ENTITY_2) }
				</div>
			);
		}
		if (_.indexOf(STAGES, stage) == 5) {
			var causeEffectDisplay = (
				<div>
					{ this.props.getTextF("label1", CAUSE_EFFECT_STAGE) }
					{ this.props.renderInputF(CAUSE) }
					<br />
					{ this.props.getTextF("label2", CAUSE_EFFECT_STAGE) }
					{ this.props.renderInputF(EFFECT) }
				</div>
			);
		}
		if (_.indexOf(STAGES, stage) == 6) {
			var problemSolutionDisplay = (
				<div>
					{ this.props.getTextF("label1", PROBLEM_SOLUTION_STAGE) }
					{ this.props.renderInputF(PROBLEM) }
					<br />
					{ this.props.getTextF("label2", PROBLEM_SOLUTION_STAGE) }
					{ this.props.renderInputF(SOLUTION) }
				</div>
			);
		}
		if (_.indexOf(STAGES, stage) == 7) {
			var descriptionDisplay = (
				<div>
					{ this.props.getTextF("label1", DESCRIPTION_STAGE) }
					{ this.props.renderInputF(SUBJECT) }
					<br />
					{ this.props.getTextF("label2", DESCRIPTION_STAGE) }
					{ this.props.renderInputF(DESCRIPTION) }
				</div>
			);
		}

		return (
			<div>
				{ numPagesDisplay }
				{ orgStructureDisplay }
				{ randomHeadingDisplay }
				{ chronologicalDisplay }
				{ comparisonDisplay }
				{ causeEffectDisplay }
				{ problemSolutionDisplay }
				{ descriptionDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}

	componentDidUpdate(oldProps) {
		var oldAnswers = oldProps.answers[NonFictionOrganizationQuestion.STEM];
		var newAnswers = this.props.answers[NonFictionOrganizationQuestion.STEM];
		if (oldAnswers && newAnswers) {
			var optionKey = NUM_HEADINGS;

			if (newAnswers[optionKey] && (oldAnswers[optionKey] != newAnswers[optionKey])) {
				var options = [];
				for (var i = 1; i <= parseInt(newAnswers[optionKey]); i++) {
					options.push($wr.getOrdinal(i));
				}

				this.props.pickRandomOptionF(SEL_HEADING_NUMBER, options);
			}
		}
	}
}

NonFictionOrganizationQuestion.STEM = "nforg";

// stages
var NUM_PAGES_STAGE = "numpages";
var ORG_STRUCTURE_STAGE = "orgstructure";
var RANDOM_HEADING_STAGE = "headinginfo";
var CHRONOLOGICAL_STAGE = "chronological";
var COMPARISON_STAGE = "comparison";
var CAUSE_EFFECT_STAGE = "causeeffect";
var PROBLEM_SOLUTION_STAGE = "problemsolution";
var DESCRIPTION_STAGE = "description";

var STAGES = [
	NUM_PAGES_STAGE, ORG_STRUCTURE_STAGE, RANDOM_HEADING_STAGE, CHRONOLOGICAL_STAGE,
	COMPARISON_STAGE, CAUSE_EFFECT_STAGE, PROBLEM_SOLUTION_STAGE, DESCRIPTION_STAGE
];

// answer keys
var NUM_PAGES = "num_pages";
var NUM_HEADINGS = "num_headings";
var SEL_HEADING_NUMBER = "selected_heading_number";
var SEL_HEADING_DESCRIPTION = "selected_heading_description";
var STRUCTURE_TYPE = "structure_type";
var EVENT_1 = "event_1";
var EVENT_2 = "event_2";
var SPECIFIC_ENTITY_1 = "specific_entity_1";
var SPECIFIC_ENTITY_2 = "specific_entity_2";
var CAUSE = "cause";
var EFFECT = "effect";
var PROBLEM = "problem";
var SOLUTION = "solution";
var SUBJECT = "subject";
var DESCRIPTION = "description";

NonFictionOrganizationQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
	pickRandomOptionF: PropTypes.func.isRequired,
});

module.exports = NonFictionOrganizationQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/NonFictionOrganizationQuestion.js